/* eslint-disable react/prop-types */
import { Tab, Tabs, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import Iconify from '../../components/Iconify';
import useLocales from '../../hooks/useLocales';
// ----------------------------------------------------------------------

export default function ExerciseTab({ exercise, tab }) {
  const { translate } = useLocales();
  const router = useRouter();

  const TABS = [
    {
      value: 'description',
      label: translate("hackerthon.exercise.description"),
      icon: "ph:question"
    },
    {
      value: 'discussion',
      label: translate("hackerthon.exercise.discussion"),
      icon: "ant-design:comment-outlined"
    },
    {
      value: 'solutions',
      label: translate("hackerthon.exercise.solution"),
      icon: "icons8:idea"
    },
    {
      value: 'submissions',
      label: translate("hackerthon.exercise.submission"),
      icon: "bx:archive"
    },
  ];

  const handleChangeTab = (_, v) => {
    router.push(`/exercises/${exercise.slug}/${v}`);
  };

  return (
    <Tabs value={tab} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile
      sx={{ boxShadow: 1, px: 1, mb: 1 }}>
      {TABS.map((t) => (
        <Tab key={t.value} value={t.value}
          label={<Typography variant='subtitle2' sx={{ textTransform: 'initial' }}>{t.label}</Typography>}
          icon={<Iconify icon={t.icon} width={16} height={16} />} />
      ))}
    </Tabs>
  );
}